<template>
    <div>
        <div>
            {{ agencyName }}
        </div>
        <div>
            {{ programName }}
        </div>
        <br />
        <div v-if="supportPhone">
            {{ phoneLabel }}
            <div>
                {{ supportPhone }}
            </div>
        </div>
        <br />
        <div v-if="supportEmail">
            {{ emailLabel }}
            <div>
                <a
                    v-bind:href="mailTo"
                    target="_blank"
                    class="text-break">
                    {{ supportEmail }}
                </a>
            </div>
        </div>
        <br />
        <div v-if="supportWebsite">
            <a
                v-bind:href="supportWebsiteUrl"
                target="_blank"
                class="text-break">
                {{ supportWebsite }}
            </a>
        </div>
    </div>
</template>

<script>
    import { KEYS, NAMESPACE } from "./i18n/navbar.i18n";
    import { mapI18n } from "Util/i18n";

    export default {
        computed: {
            agencyName() {
                return this.$app.ProgramInfo.AgencyDisplayName;
            },
            programName() {
                return this.$app.ProgramInfo.DisplayName;
            },
            supportPhone() {
                return this.$app.ProgramInfo.SupportPhone;
            },
            supportEmail() {
                return this.$app.ProgramInfo.SupportEmail;
            },
            mailTo() {
                return `mailto:${this.supportEmail}`;
            },
            supportWebsite() {
                return this.$app.ProgramInfo.SupportWebsite;
            },
            supportWebsiteUrl() {
                return this.$app.ProgramInfo.SupportWebsiteUrl;
            },
            ...mapI18n(KEYS, NAMESPACE)
        }
    };
</script>
